// extracted by mini-css-extract-plugin
export var actionText = "_ou-4";
export var container = "_ou-0";
export var leftSection = "_ou-1";
export var rightSection = "_ou-2";
export var settingsButton = "_ou-6";
export var settingsIcon = "_ou-7";
export var shortcut = "_ou-5";
export var shortcutGroup = "_ou-3";